import { useCallback, useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { adminShop } from "../../lib/shopApi";
import { ShopProductsTab } from "./ShopProductsTab";
import { ShopOrdersTab } from "./ShopOrdersTab";
import { ShopSettingsTab } from "./ShopSettingsTab";

const Pill = ({ ok, children, testid }) => (
  <span data-testid={testid} className={`px-3 py-1 rounded-full text-[11px] uppercase tracking-[0.15em] ${ok ? "bg-[#E6EFD9] text-[#4E6B2F]" : "bg-[#FBE9E7] text-[#A3302A]"}`}>
    {children}
  </span>
);

export default function AdminShop({ passcode }) {
  const [status, setStatus] = useState(null);
  const loadStatus = useCallback(() => adminShop.status(passcode).then(setStatus).catch(() => {}), [passcode]);
  useEffect(() => { loadStatus(); }, [loadStatus]);

  return (
    <div data-testid="admin-shop">
      {status && (
        <div className="flex flex-wrap gap-2 mb-6" data-testid="admin-shop-status">
          <Pill ok testid="admin-shop-stripe-mode">{status.stripe_test_mode ? "Stripe: test mode" : "Stripe: LIVE"}</Pill>
          <Pill ok={status.printful_connected} testid="admin-shop-printful-status">
            {status.printful_connected ? `Printful connected · ${status.printful_store}` : "Printful not connected"}
          </Pill>
          <Pill ok testid="admin-shop-fulfillment-mode">
            {status.live_fulfillment ? "Real orders sent to print shops" : "Safe mode: Printful orders saved as drafts only"}
          </Pill>
          {!status.alert_email && <Pill ok={false} testid="admin-shop-alert-missing">No alert email set — add one in Settings</Pill>}
        </div>
      )}
      <Tabs defaultValue="products">
        <TabsList className="bg-[#EFE6D8] mb-6">
          <TabsTrigger value="products" data-testid="admin-shop-tab-products">Products</TabsTrigger>
          <TabsTrigger value="orders" data-testid="admin-shop-tab-orders">Orders</TabsTrigger>
          <TabsTrigger value="settings" data-testid="admin-shop-tab-settings">Settings</TabsTrigger>
        </TabsList>
        <TabsContent value="products"><ShopProductsTab passcode={passcode} printfulConnected={status?.printful_connected} /></TabsContent>
        <TabsContent value="orders"><ShopOrdersTab passcode={passcode} /></TabsContent>
        <TabsContent value="settings"><ShopSettingsTab passcode={passcode} status={status} reload={loadStatus} /></TabsContent>
      </Tabs>
    </div>
  );
}
